module.exports = __webpack_public_path__ + "img/3.d46864c7.webp";